import { useCallback, ReactElement } from "react";
import { useSelector } from "react-redux";
import { PaymentFieldConfig } from "@evergiving/common/dist/es2015/form";

import { RootState } from "@/lib/redux/types";
import { PaymentFrequency } from "@evergiving/common/dist/es2015/pledge";
import { Text } from "@/lib/components/Text";
import { FormattedNumber } from "@/lib/components/FormattedNumber";
import { amountSelector } from "@/lib/misc/amountSelector";
import { useFormRouter } from "@/lib/hooks/useFormRouter";

export function Nav({
  locale,
  paymentFieldConfig,
}: {
  locale: string;
  paymentFieldConfig: PaymentFieldConfig;
}): ReactElement {
  const amount = useSelector(amountSelector);
  const paymentFrequency: PaymentFrequency | undefined = useSelector(
    (state: RootState) => state.paymentFrequency
  );

  const frequencyConfig = paymentFrequency
    ? paymentFieldConfig.frequencies[paymentFrequency]
    : null;

  const formRouter = useFormRouter();

  const handleBack = useCallback(() => {
    formRouter.goBack();
  }, [formRouter]);

  return (
    <nav>
      <div className="donationSummary">
        {frequencyConfig && (
          <span className="frequency">
            <Text value={frequencyConfig.summaryTemplateText} />
          </span>
        )}
        <span className="amount">
          <FormattedNumber
            locale={locale}
            value={amount.value * 0.01}
            currency={amount.currency}
          />
        </span>
      </div>
      <button type="button" className="back" onClick={handleBack}>
        {paymentFieldConfig.changeAmountOrFrequencyButtonText}
      </button>
    </nav>
  );
}
